import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { IconButton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const doctors = new Array(8).fill('Brinkman, Jos');

export default function OverviewNewPage() {
  const navigate = useNavigate();

  const [selectedIndex, setSelectedIndex] = useState(null);

  return (
    <div className="flex flex-col items-start">
      <div className="w-full px-10 pt-6 pb-4">
        <div className="text-[#015A52] pb-1.5 pr-3 w-fit font-medium border-b-2 border-[#015A52] text-xl">
          All Doctors
        </div>
      </div>

      <div className="flex flex-col gap-3 w-full px-2 pb-10">
        {doctors.map((doctor, index) => (
          <div key={index} className="flex gap-1">
            <IconButton disableRipple size="small">
              <DragIndicatorIcon className="text-gray-400" />
            </IconButton>

            <div
              elevation={selectedIndex === index ? 3 : 1}
              onClick={() => {
                setSelectedIndex(index);
                navigate('/home/nextpatient/slots');
              }}
              className={`w-full flex items-center gap-2 p-3 cursor-pointer font-medium rounded-xl transition-all
                ${
                  selectedIndex === index
                    ? 'border-2 border-blue-600'
                    : 'border border-gray-200'
                } bg-[#F7F7F7] hover:bg-gray-200`}
            >
              {doctor}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
